import { FC } from 'react';
import { Box, IconButton, Stack, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { AgentPermissionsEnum } from 'enums/accessTemplates';

import useAuth from 'store/auth';
import useScreen from 'hooks/useScreen';
import { AccessChangePartnerPermissions } from 'utils/accessTemplates';

import UserMenu from './UserMenu';
import WebsitesMenu from './WebsitesMenu';
import SearchBox from './SearchBox';
import PopupMenu from './PopupMenu';
import BalanceMenu from './BalanceMenu';
import sx from './styles';

export interface HeaderNavigationProps {
  setSidebarOpen: (isOpen: boolean) => void;
}

const HeaderNavigation: FC<HeaderNavigationProps> = ({ setSidebarOpen }) => {
  const theme = useTheme();
  const { isMobile } = useScreen();
  const [authState] = useAuth();
  const permissions = authState?.data?.agent?.permissions;

  return (
    <Box sx={isMobile ? sx.sx.root : sx.lg.root}>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          [theme.breakpoints.down('sm')]: {
            flexGrow: 2,
          },
        }}
      >
        {isMobile ? (
          <IconButton onClick={(): void => setSidebarOpen(true)}>
            <MenuIcon />
          </IconButton>
        ) : (
          AccessChangePartnerPermissions.some((r) => permissions?.includes(r)) && <WebsitesMenu />
        )}
        <SearchBox />
      </Stack>
      <Box flex={1} display="flex" alignItems="center" justifyContent="flex-end">
        {!AccessChangePartnerPermissions.some((r) => permissions?.includes(r)) && (
          <BalanceMenu wallets={authState?.data?.wallets ?? []} />
        )}
        {!isMobile && (
          <>
            <PopupMenu permissions={(permissions as AgentPermissionsEnum[]) ?? []} />
            <UserMenu />
          </>
        )}
      </Box>
    </Box>
  );
};

export default HeaderNavigation;
